import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { IntegrationsActions, ValueListActions } from 'actions';
import Literal from 'components/Literal'; // FIXME Please use getLiteral here
import IntegrationActive from 'containers/settings/deprecatedIntegrationsManagement/components/IntegrationActive';
import ActivationStatus from 'containers/settings/deprecatedIntegrationsManagement/components/ActivationStatus';
import { NavigationTree } from 'containers/settings/deprecatedIntegrationsManagement/components/';
import ProviderDetail from 'containers/settings/deprecatedIntegrationsManagement/components/ProviderDetail';
import {
    ACTIVATION_STATUS_INACTIVE,
    ACTIVATION_STATUS_OAUTH,
    ACTIVATION_STATUS_TO_CHECK,
    ACTIVATION_STATUS_CHECKING,
    ACTIVATION_STATUS_INVALID,
    ACTIVATION_STATUS_ACTIVE,
    ACTIVATION_STATUS_ERROR,
} from 'containers/settings/deprecatedIntegrationsManagement/constants';
import './style.scss';

const mapStateToProps = (state) => {
    return {
        loading: state.integrations.loading,
        error: state.integrations.error,
        provider: state.integrations.provider,
        providerId: state.integrations.provider.data.ProviderId,
        implementation: state.config.userData.idImplementacion,
        iduser: state.config.userData.idUsuario,
        isActive: state.integrations.provider.data.IsActive,
        activationStatus: state.integrations.activationStatus,
        cronstatus: state.integrations.cronstatus,
        errorType: state.integrations.errorType,
        fmFields: state.integrations.fmFields,
        fmUsers: state.integrations.fmUsers,
        extFields: state.integrations.extFields,
        extUsers: state.integrations.extUsers,
        fieldsConfig: state.integrations.fieldsConfig,
        usersConfig: state.integrations.usersConfig,
        stepper: state.integrations.stepper,
        stage: state.integrations.stepper.stage,
        steps: state.integrations.stepper.steps,
        stepperFinish: state.integrations.stepper.finish,
        syncroLogs: state.integrations.syncLogs,
        syncroStats: state.integrations.syncStats,
        valueList: state.valueList,
    };
};

const mapDispatchToProps = (dispatch) => {
    const {
        getProvider,
        clear,
        activationCheck,
        setIntegrationActive,
        oAuthLogin,
        disableIntegration,
        resetError,
        getCronStatus,
        pauseCron,
        resumeCron,
        getIntegrationsFmFields,
        getIntegrationsFmUsers,
        getIntegrationsSageFields,
        getIntegrationsSageUsers,
        getIntegrationsSageFieldsConfig,
        getIntegrationsSageUsersConfig,
        getSageSyncroLogs,
        getSageSyncroStats,
        setIntegrationsFieldsConfig,
        setIntegrationsUsersConfig,
        setInitialIntegrationsFieldsConfig,
        addIntegrationsFieldsConfig,
        addIntegrationsUsersConfig,
        addIntegrationsUsersAutoConfig,
        deleteIntegrationsUsersConfig,
        createOrUpdateJob,
        integrationsStepperSetSteps,
        integrationsStepperSetStage,
        integrationsStepperReset,
        integrationsStepperCancel,
    } = bindActionCreators(IntegrationsActions, dispatch);
    const { getValueList } = bindActionCreators(ValueListActions, dispatch);

    return {
        getProvider,
        clear,
        activationCheck,
        setIntegrationActive,
        oAuthLogin,
        disableIntegration,
        resetError,
        getCronStatus,
        pauseCron,
        resumeCron,
        getIntegrationsFmFields,
        getIntegrationsFmUsers,
        getIntegrationsSageFields,
        getIntegrationsSageUsers,
        getIntegrationsSageFieldsConfig,
        getIntegrationsSageUsersConfig,
        getSageSyncroLogs,
        getSageSyncroStats,
        setIntegrationsFieldsConfig,
        setIntegrationsUsersConfig,
        setInitialIntegrationsFieldsConfig,
        addIntegrationsFieldsConfig,
        addIntegrationsUsersConfig,
        addIntegrationsUsersAutoConfig,
        deleteIntegrationsUsersConfig,
        createOrUpdateJob,
        integrationsStepperSetSteps,
        integrationsStepperSetStage,
        integrationsStepperReset,
        integrationsStepperCancel,
        getValueList,
    };
};

class SageComponent extends Component {
    state = {};

    constructor(props) {
        super(props);
        const { providerData, getProvider } = this.props;
        getProvider && getProvider(providerData);
        this.literals = {
            label_error_integration_descript_getting_data:
                'label_error_sagelive_descript_getting_data',
            label_integration_getting_data_description: 'label_sagelive_getting_data_description',
            label_integration_ext_fields: 'label_sagelive_sl_fields',
            label_integration_user_matching_description: 'label_sagelive_user_matching_description',
            label_integration_sl_users: 'label_sagelive_sl_users',
            label_integration_match_fields_description: 'label_sagelive_match_fields_description',
            label_integration_bidirectional_info_box: 'label_sagelive_bidirectional_info_box',
            label_integration_sl_fields: 'label_sagelive_sl_fields',
            label_integration_unidirectional_info_box: 'label_sagelive_unidirectional_info_box',
            label_error_integration_descript_users: 'label_error_sagelive_descript_users',
            label_enabled_sync_description_integration: 'label_enabled_sync_description_sagelive',
            label_sync_description_integration: 'label_sync_description_sagelive',
            label_no_logs_data_integration: 'label_no_logs_data_sagelive',
            label_no_stats_data_integration: 'label_no_stats_data_sagelive',
            label_insert_contact_integration: 'label_insert_contact_sagelive',
            label_update_contact_integration: 'label_update_contact_sagelive',
            label_delete_contact_integration: 'label_delete_contact_sagelive',
        };
    }

    componentDidUpdate() {
        const { activationStatus, activationCheck, setIntegrationActive, providerId, isActive } =
            this.props;
        switch (activationStatus) {
            case ACTIVATION_STATUS_INACTIVE:
                break;
            case ACTIVATION_STATUS_OAUTH:
                break;
            case ACTIVATION_STATUS_TO_CHECK:
                activationCheck(providerId);
                break;
            case ACTIVATION_STATUS_CHECKING:
                break;
            case ACTIVATION_STATUS_ACTIVE:
                if (!isActive) {
                    setIntegrationActive(providerId);
                }
                break;
            case ACTIVATION_STATUS_ERROR:
                break;
            default:
                break;
        }
    }

    componentWillUnmount() {
        const { clear } = this.props;
        clear && clear();
    }

    handleActivationToggle = () => {
        const { oAuthLogin, disableIntegration, providerId, iduser, implementation, isActive } =
            this.props;
        if (isActive) {
            disableIntegration(providerId);
        } else {
            oAuthLogin(iduser, implementation);
        }
    };

    handleActivationButton = () => {
        const { oAuthLogin, iduser, implementation } = this.props;
        oAuthLogin(iduser, implementation);
    };

    renderContent() {
        const {
            activationStatus,
            getSageSyncroLogs,
            getSageSyncroStats,
            getIntegrationsSageFields,
            getIntegrationsSageUsers,
            getIntegrationsSageFieldsConfig,
            getIntegrationsSageUsersConfig,
        } = this.props;
        let content;
        switch (activationStatus) {
            case ACTIVATION_STATUS_OAUTH:
                content = (
                    <ActivationStatus
                        type={'spinner'}
                        title={''}
                        text={'label_integration_status_activating'}
                    />
                );
                break;
            case ACTIVATION_STATUS_TO_CHECK:
                content = (
                    <ActivationStatus
                        type={'spinner'}
                        title={''}
                        text={'label_integration_status_activating'}
                    />
                );
                break;
            case ACTIVATION_STATUS_CHECKING:
                content = (
                    <ActivationStatus
                        type={'spinner'}
                        title={''}
                        text={'label_integration_status_checking'}
                    />
                );
                break;
            case ACTIVATION_STATUS_INVALID:
                content = (
                    <ActivationStatus
                        type={'error'}
                        title={''}
                        text={'label_integration_status_invalid'}
                        handleActivationButton={this.handleActivationButton}
                    />
                );
                break;
            case ACTIVATION_STATUS_ACTIVE:
                content = (
                    <IntegrationActive
                        {...this.props}
                        integration={'sagelive'}
                        literals={this.literals}
                        getSyncroLogs={getSageSyncroLogs}
                        getSyncroStats={getSageSyncroStats}
                        getIntegrationsExtFields={getIntegrationsSageFields}
                        getIntegrationsExtUsers={getIntegrationsSageUsers}
                        getIntegrationsFieldsConfig={getIntegrationsSageFieldsConfig}
                        getIntegrationsUsersConfig={getIntegrationsSageUsersConfig}
                    />
                );
                break;
            case ACTIVATION_STATUS_ERROR:
                content = (
                    <ActivationStatus
                        type={'error'}
                        title={''}
                        text={'label_integration_status_generic_error'}
                        handleActivationButton={this.handleActivationButton}
                    />
                );
                break;
            case ACTIVATION_STATUS_INACTIVE:
            default:
                content = null;
                break;
        }

        return <div>{content}</div>;
    }

    renderHeader() {
        const { provider, onReset, isActive } = this.props;
        let activationLabel = isActive ? 'action_deactivate' : 'action_activate';
        if (provider) {
            return (
                <div>
                    <NavigationTree provider={provider} onReset={onReset} />
                    <ProviderDetail
                        provider={provider}
                        activationValue={isActive}
                        activationLabel={activationLabel}
                        onActivationChange={this.handleActivationToggle}
                    />
                    <div className="provider-title-description">
                        <div className="provider-title">
                            <Literal
                                className="provider-title-label"
                                literal="label_sagelive_welcome"
                            />
                        </div>
                        <div className="provider-description">
                            <Literal literal="label_sagelive_description_long" />
                        </div>
                    </div>
                </div>
            );
        }
    }

    render() {
        return (
            <div className="detail-provider">
                <div className="top-panel">
                    {this.renderHeader()}
                    {this.renderContent()}
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SageComponent);
